import { Component, HostBinding, OnInit } from '@angular/core';
import { ScreenService, AppInfoService } from './shared/services';
import { AuthService } from './shared/services/auth/auth.service';
import { ImpersonationService } from './shared/services/impersonation.service';
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  constructor(
    private authService: AuthService, 
    private screen: ScreenService, 
    public appInfo: AppInfoService,
    private impersonationService: ImpersonationService
  ) {
    loadMessages(esMessages);
    // Forzar locale español para DevExtreme
    locale('es-ES');
  }

  ngOnInit() {
    // Verificar el estado de la sesión al inicializar la aplicación
    this.validateApplicationState();
  }

  /**
   * Valida el estado de la aplicación al iniciar
   */
  private validateApplicationState(): void {
    console.log('🔍 Validando estado de la aplicación al iniciar...');
    
    try {
      // Verificar si hay un usuario en localStorage pero no en el servicio
      const storedUser = localStorage.getItem('currentUser');
      const currentUser = this.authService.getUser;
      
      if (storedUser && !currentUser) {
        console.log('🔄 Usuario encontrado en localStorage pero no en servicio - restaurando');
        const userData = JSON.parse(storedUser);
        
        if (this.authService.isTokenValid(userData.JwtToken)) {
          this.authService.currentUser.next(userData);
          console.log('✅ Usuario restaurado desde localStorage');
        } else {
          console.log('🚨 Token en localStorage vencido - limpiando');
          this.authService.clearCorruptedSession('Token vencido al iniciar');
        }
      }
      
      // Validar estado de impersonalización
      if (this.impersonationService.isImpersonating()) {
        const originalUser = this.impersonationService.getOriginalUser();
        
        if (!originalUser) {
          console.log('🚨 Estado de impersonalización corrupto detectado al iniciar - limpiando');
          this.impersonationService.forceRestoreOriginalUser();
        } else {
          console.log('✅ Estado de impersonalización válido al iniciar');
        }
      }
      
      // Validar estado general de la sesión
      this.authService.validateSessionState();
      
      console.log('✅ Validación de estado de aplicación completada');
    } catch (error) {
      console.error('❌ Error durante validación de estado de aplicación:', error);
      
      // En caso de error crítico, limpiar todo
      this.authService.clearCorruptedSession('Error crítico al validar estado');
    }
  }

  isAuthenticated() {
    return this.authService.loggedIn;
  }
}
